import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Body from './components/Body';
import About from './components/About';
import Blog from './components/Blog';
import BlogArticle from './components/BlogArticle';
import Contact from './components/Contact';
import NotFound from './components/NotFound';  // Import the NotFound component
import './styles/App.css';

function App() {
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'ar'
  );

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <Router>
      <div className="App">
        <main className="main-content">
        <Header language={language} setLanguage={setLanguage} />
        <Routes>
          <Route path="/" element={<Body language={language} />} />
          <Route path="/about" element={<About language={language} />} />
          <Route path="/submit" element={<Contact language={language} />} />
          <Route path="/blog" element={<Blog language={language} />} />
          <Route path="/blog/:slug" element={<BlogArticle language={language} />} />
          <Route path="*" element={<NotFound language={language} />} /> {/* Catch-all route for 404 */}
        </Routes>
        </main>
        <Footer language={language} />
      </div>
    </Router>
  );
}

export default App;
